import * as React from "react";
import PropTypes from "prop-types";
import Heading from "./Heading";
import Theme from "./Theme";

const Section = ({ children, style, label }) => {
  const styles = {
    content: {
      position: "relative",
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: Theme.Padding.CONTENT,
      paddingRight: Theme.Padding.CONTENT,
      ...style,
    },
    section: {
      margin: "0.9em 0", // 0.9em collapses into Header margin when present
    },
  };
  return (
    <section
      data-component-name="Section"
      data-component-prop-label={label}
      aria-label={label}
      tabIndex={0}
      style={styles.section}
    >
      {label && (
        <Heading label={label} style={{ marginLeft: Theme.Padding.CONTENT }} />
      )}
      <div style={styles.content} data-component-section="content">
        {children}
      </div>
    </section>
  );
};
Section.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  style: PropTypes.object,
};

export default Section;



// WEBPACK FOOTER //
// ../nx-components/src/Section.jsx